<div>
    <eris-table [dataSource]="transfersDataSource" [menuConfiguration]="menuConfiguration" #parent>
        <ng-container *ngFor="let transfer of parent.data; index as i">
            <tr *ngIf="!audience">
                <td scope="row" class="align-middle text-center" style="width: 8%;"><img width="48px" height="48px"
                        [src]="transfersService.getTargetPlatformIcon(transfer)" /></td>
                <th scope="row" class="align-middle" style="width: 4%;">{{ transfer.id }}</th>
                <td scope="row" class="align-middle" style="width: 15%; word-break: break-all;">{{ transfer.name }}</td>
                <td scope="row" class="align-middle" style="width: 20%; word-break: break-all;">{{ transfer.audience.id
                    }} - {{ transfer.audience.name }}</td>
                <td scope="row" class="align-middle" style="width: 8%;">{{ transfer.created | date }}</td>
                <td scope="row" class="align-middle" style="width: 7%;">
                    {{ transfer.scheduling.description }}
                    <span *ngIf="!!transfer.schedulingEndDate">until {{ transfer.schedulingEndDate | date }}</span>
                    <span *ngIf="!transfer.schedulingEndDate &&  transfer.schedulingId != 1">indefinitely</span>
                </td>
                <td scope="row" class="align-middle" style="width: 20%; word-break: break-all;">
                    <ng-container *ngIf="getSharedAudienceInfo(transfer) as info">
                        <a [attr.href]="info.isLink ? '#' : null"
                        (click)="onSharedAudienceClick($event, transfer, info.isLink)">
                            {{ info.text }}
                        </a><br />
                    </ng-container>
                    <ng-container *ngFor="let attribute of getVisibleTransferAttributes(transfer)">
                        {{ transfersService.getTransferAttributeDescription(
                            attribute.attributeId,
                            transfer.targetPlatform
                        ) }} : {{ attribute.value }}<br />
                    </ng-container>
                </td>
                <td scope="row" class="align-middle text-center" style="width: 6%; word-break: break-all;">
                    <ng-container *ngFor="let idGraphType of transfer.identifiersTypes">
                        <img [src]="audiencesService.getIdentifiersTypeSmallIcon(idGraphType)"
                            [title]="audiencesService.getIdGraphTypeDescription(idGraphType)" alt="icon"
                            style="width: 24px; height: 24px; margin: 3px;">
                    </ng-container>
                </td>
                <td scope="row" class="align-middle text-center" style="width: 5%;"
                    *ngIf="usersService.hasSelectedCompanyActionRight('Audiences', 'AudiencesList', 'Manage')">
                    <div *ngIf="transfer?.files?.length > 0" (click)="toggleTransferFilesVisibility(transfer)"
                        class="btn-success badge badge-pill badge-success"
                        style="padding: 0.4rem 0.6rem; margin-left: 0.5rem;">
                        {{transfer?.files?.length}} files
                        <i class="fa fa-angle-up" aria-hidden="true"
                            style="margin:3px; font-size: 1rem;vertical-align: middle;"
                            *ngIf="filesVisibleTransferId == transfer.id"> </i>
                        <i class="fa fa-angle-down" aria-hidden="true"
                            style="margin:3px;font-size: 1rem;vertical-align: middle;"
                            *ngIf="filesVisibleTransferId != transfer.id"> </i>
                    </div>
                </td>
                <td scope="row" class="align-middle" style="width: 2%;"
                    *ngIf="usersService.hasSelectedCompanyActionRight('Audiences', 'AudiencesTransfers', 'Manage')">
                    <div *ngIf="audience?.status != 10">
                        <eris-menu
                            [context]="transfer"
                            [menuConfiguration]="menuConfigurationTransfer"
                            [onMenuClosed]="onMenuClosedInternal"
                            [onMenuOpened]="onMenuOpenedInternal"
                        ></eris-menu>
                    </div>
                </td>
            </tr>
            <!-- Single audience row -->
            <tr *ngIf="!!audience">
                <td scope="row" class="align-middle text-center" style="width: 8%;"><img width="48px" height="48px"
                        [src]="transfersService.getTargetPlatformIcon(transfer)" /></td>
                <th scope="row" class="align-middle" style="width: 7%;">{{ transfer.id }}</th>
                <td scope="row" class="align-middle" style="width: 25%; word-break: break-all;">{{ transfer.name }}</td>
                <td scope="row" class="align-middle" style="width: 10%;">{{ transfer.created | date }}</td>
                <td scope="row" class="align-middle" style="width: 8%;">
                    {{ transfer.scheduling.description }}
                    <span *ngIf="!!transfer.schedulingEndDate">until {{ transfer.schedulingEndDate | date }}</span>
                    <span *ngIf="!transfer.schedulingEndDate &&  transfer.schedulingId != 1">indefinitely</span>
                </td>
                <td scope="row" class="align-middle" style="width: 20%; word-break: break-all;">
                    <ng-container *ngIf="getSharedAudienceInfo(transfer) as info">
                        <a [attr.href]="info.isLink ? '#' : null"
                        (click)="onSharedAudienceClick($event, transfer, info.isLink)">
                            {{ info.text }}
                        </a><br />
                    </ng-container>
                    <ng-container *ngFor="let attribute of getVisibleTransferAttributes(transfer)">
                        {{ transfersService.getTransferAttributeDescription(
                            attribute.attributeId,
                            transfer.targetPlatform
                        ) }} : {{ attribute.value }}<br />
                    </ng-container>
                </td>
                <td scope="row" class="align-middle text-center" style="width: 10%; word-break: break-all;">
                    <ng-container *ngFor="let idGraphType of transfer.identifiersTypes">
                        <img [src]="audiencesService.getIdentifiersTypeSmallIcon(idGraphType)"
                            [title]="audiencesService.getIdGraphTypeDescription(idGraphType)" alt="icon"
                            style="width: 24px; height: 24px; margin: 3px;">
                    </ng-container>
                </td>
                <td scope="row" class="align-middle text-center" style="width: 5%;"
                    *ngIf="usersService.hasSelectedCompanyActionRight('Audiences', 'AudiencesList', 'Manage')">
                    <div *ngIf="transfer?.files?.length > 0" (click)="toggleTransferFilesVisibility(transfer)"
                        class="btn-success badge badge-pill badge-success"
                        style="padding: 0.4rem 0.6rem; margin-left: 0.5rem;">
                        {{transfer?.files?.length}} files
                        <i class="fa fa-angle-up" aria-hidden="true"
                            style="margin:3px; font-size: 1rem;vertical-align: middle;"
                            *ngIf="filesVisibleTransferId == transfer.id"> </i>
                        <i class="fa fa-angle-down" aria-hidden="true"
                            style="margin:3px;font-size: 1rem;vertical-align: middle;"
                            *ngIf="filesVisibleTransferId != transfer.id"> </i>
                    </div>
                </td>
                <td scope="row" class="align-middle" style="width: 2%;"
                    *ngIf="usersService.hasSelectedCompanyActionRight('Audiences', 'AudiencesList', 'Manage')">
                    <div *ngIf="audience?.status != 10">
                        <eris-menu
                            [context]="transfer"
                            [menuConfiguration]="menuConfigurationTransfer"
                            [onMenuClosed]="onMenuClosedInternal"
                            [onMenuOpened]="onMenuOpenedInternal"
                        ></eris-menu>
                    </div>
                </td>
            </tr>
            <!-- Files for transfer -->
            <tr *ngIf="filesVisibleTransferId == transfer.id">
                <th scope="row" colspan="1"></th>
                <td colspan="10">
                    <table class="table table-striped">
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">ID</th>
                            <th scope="col">Creation date</th>
                            <th scope="col">Size</th>
                            <th scope="col">Times sent</th>
                            <th scope="col">Last sent date</th>
                            <th scope="col">Status</th>
                            <th scope="col"></th>
                        </tr>
                        <tr *ngFor="let file of transfer.files; index as j">
                            <th class="align-middle" style="width: 5%;">
                                <div class="font-icon-wrapper">
                                    <i class="fa fa-file-text" aria-hidden="true" style="font-size: 1.5rem;"> </i>                                    
                                </div>
                            </th>
                            <th class="align-middle" style="width: 5%;">{{ file.id }}</th>
                            <td class="align-middle" style="width: 15%;">{{ file.created | date }}</td>
                            <td class="align-middle" style="width: 10%;">{{ file.bytesSize | bytes }}</td>
                            <td class="align-middle" style="width: 5%;">{{ file.timesSent.length }}</td>
                            <td class="align-middle" style="width: 15%;">{{ file.timesSent.length > 0 ?
                                (file.timesSent[file.timesSent.length - 1].timeSent | date:'medium') : '' }}</td>
                            <td class="align-middle" style="width: 10%;">
                                <div>
                                    <div class="font-icon-wrapper">
                                        <i [class]="transfersService.getFileStatusClass(file)"></i>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        {{ transfersService.getFileStatusLabel(file) }}
                                    </div>
                                </div>
                            </td>
                            <td class="align-middle" style="width: 15%;">
                                <div class="btn" style="padding: 0.1rem 0.1rem" title="Download audience file">
                                    <div class="font-icon-wrapper-medium" (click)="downloadFile(transfer, file)"
                                        *ngIf="showFileButton(TransferFileAction.Download, transfer, file)">
                                        <i class="fa fa-download" aria-hidden="true" style="font-size: 1.5rem; position: relative; top: 1px;"> </i>                                    
                                    </div>
                                </div>
                                <div class="btn" style="padding: 0.1rem 0.1rem" title="Send audience file"
                                    *ngIf="showFileButton(TransferFileAction.Send, transfer, file)">
                                    <div class="font-icon-wrapper-medium" (click)="sendFile(transfer, file)">
                                        <i class="fa fa-upload" aria-hidden="true" style="font-size: 1.5rem;"> </i>                                    
                                    </div>
                                </div>
                                <div class="btn" style="padding: 0.1rem 0.1rem" title="Delete audience file"
                                    *ngIf="showFileButton(TransferFileAction.Delete, transfer, file)">
                                    <div class="font-icon-wrapper-medium" (click)="deleteFile(transfer, file)">
                                        <i class="fa fa-trash" aria-hidden="true" style="font-size: 1.5rem;"> </i>                                    
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </td>
                <th scope="row" colspan="1"></th>
            </tr>
        </ng-container>
    </eris-table>
</div>